import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import state from './states';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// 路由存放位置
import Layout from './modules/Layout';
// 饿了么UI一些配置属性
import element from './modules/element';
// dom演示
import domModule from '@/components/nf-list/domModule';

// 自动导入Module模块
let modules = {};
const moduleFiles = require.context('../views', true, /Module.js$/);
moduleFiles.keys().forEach(key => {
  const keys = key.replace(/(\.\/|\.js)/g, '');
  const moduleName = _.last(keys.split('/'));
  modules[moduleName] = moduleFiles(key).default;
});

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    Layout,
    element,
    domModule,
    ...modules,
  },
});
